import { useState, useEffect, useRef } from "react";

export function usePopUpVisibility(initialValue: boolean) {
  const [isPopUpVisible, setIsPopUpVisible] = useState(initialValue);
  const ref = useRef(null);

  const handleClickOutside = (event: MouseEvent) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setIsPopUpVisible(false);
    }
  };

  const hidePopup = () => setIsPopUpVisible(false);
  const togglePopup = () => setIsPopUpVisible((prevIsPopupVisible) => !prevIsPopupVisible);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);

    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  return {
    hidePopup,
    isPopUpVisible,
    ref,
    setIsPopUpVisible,
    togglePopup,
  };
}
